export default "__VITE_ASSET__Ba25brqT__"